import React, { useEffect } from 'react';
import { CDN } from '../../constants/checkoutCom';

const Frames = (props) => {
    const {
        config,
        ready,
        frameActivated,
        frameFocus,
        frameBlur,
        frameValidationChanged,
        paymentMethodChanged,
        cardValidationChanged,
        cardSubmitted,
        cardTokenized,
        cardTokenizationFailed,
        onValidationChanged,
        isFramesElementsReady = false,
    } = props;

    useEffect(() => {
        if(isFramesElementsReady) {
            initializeFrames();

            return () => {
                cleanupEventHandlers();
            };
        }
    }, [isFramesElementsReady]);

    useEffect(() => {
        updateFramesConfig();
    }, [config]);

    const initializeFrames = () => {
        const existingScript = document.querySelector(`script[src$="${CDN}"]`);

        if (!existingScript) {
            console.error(`Checkout.com CDN not present. Perhaps you forgot to add <script src="${CDN}"></script> to your index.html file.`);

            return;
        }

        let framesConfig = {
            publicKey: config.publicKey,
            debug: config.debug || false,
            style: config.style,
            acceptedPaymentMethods: config.acceptedPaymentMethods,
            cardholder: config.cardholder,
            localization: config.localization,
            modes: config.modes,
            schemeChoice: config.schemeChoice,
            cardNumber: config.cardNumber,
            expiryDate: config.expiryDate,
            cvv: config.cvv,
            ready,
            frameActivated,
            frameFocus,
            frameBlur,
            frameValidationChanged,
            paymentMethodChanged,
            cardValidationChanged,
            cardSubmitted,
            cardTokenized,
            cardTokenizationFailed,
            onValidationChanged,
            cardBinChanged: props.cardBinChanged,
        };

        // Remove properties if they are not set as props to avoid errors
        if (!config.cardholder) delete framesConfig.cardholder;
        if (!config.schemeChoice) delete framesConfig.schemeChoice;
        if (!config.cardNumber) delete framesConfig.cardNumber;
        if (!config.expiryDate) delete framesConfig.expiryDate;
        if (!config.cvv) delete framesConfig.cvv;
        if (!config.modes) delete framesConfig.modes;
        if (!config.localization) delete framesConfig.localization;

        if (window.Frames) {
            window.Frames.init(framesConfig);

            window.Frames.addEventHandler(
                window.Frames.Events.FRAME_VALIDATION_CHANGED,
                onValidationChanged
            );
        } else {
            console.error(`Frames was used before the script (from the CDN) was loaded completely`);
        }
    };

    const updateFramesConfig = () => {
        if (config.cardholder && config.cardholder.name) {
            window.Frames.cardholder.name = config.cardholder.name;
        }
        if (config.cardholder && config.cardholder.billingAddress) {
            window.Frames.cardholder.billingAddress = config.cardholder.billingAddress;
        }
        if (config.cardholder && config.cardholder.phone) {
            window.Frames.cardholder.phone = config.cardholder.phone;
        }
    };

    const cleanupEventHandlers = () => {
        if (window.Frames) {
            removeAllEventHandlers();
        }
    };

    const removeAllEventHandlers = () => {
        const frameEvents = [
            'CARD_SUBMITTED',
            'CARD_TOKENIZATION_FAILED',
            'CARD_TOKENIZED',
            'CARD_VALIDATION_CHANGED',
            'FRAME_ACTIVATED',
            'FRAME_BLUR',
            'FRAME_FOCUS',
            'FRAME_VALIDATION_CHANGED',
            'PAYMENT_METHOD_CHANGED',
            'READY',
        ];

        frameEvents.forEach((event) => {
            window.Frames.removeAllEventHandlers(event);
        });
    };

    return props.children;
};

export default Frames;
